import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useWidgetStore = defineStore('widgets', () => {
    const allWidgets = ref(null);
    const widget = ref(null);

    const reset = () => {
        allWidgets.value = null;
        widget.value = null;
    };

    const actions = {
        saveConfig: (params) => axios.post('/api/v1/widgets', params),
        updateConfig: (hash, params) => axios.patch(`/api/v1/widgets/${hash}`, params),
    };

    return {
        allWidgets,
        widget,
        reset,
        ...actions,
    };
});

